import { useEffect, useState } from 'react'
import { FormPositions } from '../Employee/Form/formPositions'
import SalaryPositions from '../../API/Services/Salary/Positions'
import Loading from '../Loading/Loading'
import jobMatch from '../../API/JobMatch/jobMatch'

export function CreatePositions({ show, setShow, addPosition, positionToEdit, title }) {
	const [user, setUser] = useState([])
	const [errorMessage, setErrorMessage] = useState('')
	const [loading, setLoading] = useState(false)
	const company = JSON.parse(localStorage.getItem('user'))
	const companyName = company.name

	useEffect(() => {
		if (show && positionToEdit) {
			setUser({
				id: positionToEdit.id,
				position: positionToEdit.job_name,
				country: positionToEdit.country,
				level: positionToEdit.level_id,
				area: positionToEdit.area_id,
				subarea: positionToEdit.subarea,
				subareaName: positionToEdit.subarea_name,
				salary: positionToEdit.salary,
				variableSalary: positionToEdit.variable_salary,
				english: positionToEdit.english_level,
				experience: positionToEdit.seniority_level,
				training: positionToEdit.qualification,
				mydna_email_position: positionToEdit.mydna_email_position,
			})
		} else if (show && !positionToEdit) {
			setUser([])
		}
	}, [show, positionToEdit])

	useEffect(() => {
		if (!show) {
			setUser([])
		}
	}, [show])

	const handleChange = event => {
		setUser({
			...user,
			[event.target.name]: event.target.value,
		})
	}

	const validForm = () => {
		if (!user) return false

		return !!user.position && !!user.country && !!user.level && !!user.area && !!user.subareaName
	}

	const handleSubmit = async () => {
		try {
			setLoading(true)
			setErrorMessage('')

			const smtmCompanyId = await SalaryPositions.getCompanyIdSmtm(companyName)

			const sendUser = {
				name: user.position,
				country: user.country,
				company_id: JSON.parse(localStorage.getItem('user')).id,
				level_id: user.level,
				area_id: user.area,
				job_name: user.position,
				subarea_name: user.subareaName,
				english_level: user.english || 0,
				seniority_level: user.experience || 0,
				qualification: user.training || 0,
				salary: user.salary || '',
				variable_salary: user.variableSalary || 0,
				smtmCompanyId: smtmCompanyId,
				...(positionToEdit && { mydna_email_position: user.mydna_email_position }),
			}

			let response

			if (positionToEdit) {
				const sendDataSMTM = {
					job_id: user.job_id ?? user.job_id_smtm,
					job_name: user.position,
					country_id: user.country,
					subArea: user.subareaName,
					level_id: user.level,
					english_level_id: user.english,
					seniority_id: user.experience,
					qualification_id: user.training,
					current_salary: Number(user?.salary),
					variable_salary: user.variableSalary,
					area_id: user.area,
					mydna_email_position: user.mydna_email_position,
					mydna_user_name_position: user.name,
					salary_market: Math.floor(Number(user?.salary_market)),
					company_name: companyName,
				}

				await SalaryPositions.updatePosition(positionToEdit.id, sendUser)
				if (user.job_id) await jobMatch.putJobMatch(sendDataSMTM)
			} else {
				response = await SalaryPositions.postPosition(sendUser)

				const data = {
					job_id: user.job_id,
					salary_market: Math.floor(Number(user.salary_market)),
					mydna_email_position: response?.smtmEmail,
					company_name: companyName,
				}

				if (user.job_id) await jobMatch.putJobMatch(data)
			}

			sendUser.id = positionToEdit?.id ?? response?.id
			sendUser.mydna_email_position = positionToEdit?.mydna_email_position ?? response?.smtmEmail

			addPosition(sendUser)
			setUser([])
			setShow(false)
		} catch (error) {
			setErrorMessage('Error at saving position. Please try again.')
			console.log('Error:', error)
		} finally {
			setLoading(false)
		}
	}

	if (!show) return <></>

	return (
		<div className='tw-flex tw-items-center tw-justify-center tw-z-50 tw-absolute tw-top-0 tw-left-0 tw-w-screen tw-h-screen tw-bg-black/50 tw-backdrop-blur-sm'>
			<div className='tw-bg-white tw-w-[50%] tw-rounded-sm tw-shadow-md tw-p-5'>
				{loading ? (
					<Loading />
				) : errorMessage ? (
					<div className='tw-flex tw-flex-col tw-items-center tw-text-center'>
						<div className='tw-font-semibold tw-text-lg'>Error to register/create position.</div>
						<div className=''>Por favor, inténtalo de nuevo o contacta con nuestro soporte.</div>
						<div className='tw-flex tw-justify-end tw-gap-2 tw-mt-5'>
							<button
								className='tw-p-2 border-0 tw-rounded-lg tw-bg-gray-100 hover:tw-bg-gray-300 tw-cursor-pointer'
								onClick={() => {
									setShow(false)
									setErrorMessage('')
									setUser([])
								}}
							>
								Cerrar
							</button>
						</div>
					</div>
				) : (
					<>
						<FormPositions handleChange={handleChange} user={user} setUser={setUser} title={title} />
						<div className='tw-flex tw-justify-end tw-gap-2 tw-mt-5'>
							<div className='tw-p-2 tw-cursor-pointer tw-bg-gray-100 hover:tw-bg-gray-300 tw-rounded-lg' onClick={() => setShow(false)}>
								Cancelar
							</div>
							<button
								className={`tw-p-2 tw-rounded-lg tw-text-white border-0 tw-flex tw-items-center tw-justify-center tw-gap-2 ${
									validForm() && !loading ? 'tw-bg-purple-500 hover:tw-bg-purple-700 tw-cursor-pointer' : 'tw-bg-gray-400 tw-cursor-not-allowed'
								}`}
								onClick={validForm() && !loading ? handleSubmit : undefined}
								disabled={!validForm() || loading}
							>
								{loading ? (
									<>
										<span className='tw-loader tw-border-2 tw-border-white tw-border-t-transparent tw-rounded-full tw-w-4 tw-h-4 tw-animate-spin' />
										Procesando...
									</>
								) : positionToEdit ? (
									'Guardar'
								) : (
									'Crear'
								)}
							</button>
						</div>
					</>
				)}
			</div>
		</div>
	)
}
